var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconPlus = function SvgIconPlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 19"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.95 2.85a.95.95 0 1 0-1.9 0v5.7h-5.7a.95.95 0 0 0 0 1.9h5.7v5.7a.95.95 0 1 0 1.9 0v-5.7h5.7a.95.95 0 1 0 0-1.9h-5.7z"
  })));
};
export default SvgIconPlus;